<template>
  <div class="tower">
    <Top class="tower__top" :towerId="towerId" />
    <!-- Middle -->
    <img
      v-for="floor in Math.min(tower.length, 4)"
      :key="floor"
      class="tower__middle"
      src="../../assets/img/tower/middle.svg"
      width="100%"
      height="auto"
    />
    <!-- Bottom -->
    <img
      src="../../assets/img/tower/bottom.svg"
      class="tower__bottom"
      width="100%"
      height="auto"
    />

    <div class="tower__windows">
      <Floor
        v-for="(floor, index) in tower"
        :key="floor.character"
        :towerId="towerId"
        :floorId="index"
        :floor="floor"
      />
    </div>
  </div>
</template>

<script>
import Top from "./Top";
import Floor from "./Floor";

export default {
  components: { Top, Floor },
  props: ["towerId", "tower"]
};
</script>

<style lang="scss" scoped>
.tower {
  position: relative;
  z-index: 0;

  & > img {
    width: 100%;
    height: auto;
  }

  & > * {
    position: relative;
  }

  &__fire {
    z-index: 3;
    margin-bottom: -11.5% !important;
  }

  &__top {
    z-index: 2;
    // margin-bottom: -10%;
  }
  &__middle {
    z-index: 1;
    margin-bottom: -10%;
  }
  &__bottom {
    z-index: 0;
  }

  &__windows {
    position: absolute;
    display: grid;
    width: 100%;
    row-gap: vh(1.2);
    grid-template-columns: 64%;
    justify-content: center;
    grid-auto-rows: vh(14.5);

    z-index: 4;
    bottom: 0;
    padding-bottom: 22%;
  }
}
</style>
